import axios from "axios";
import API from "../api";

export const InvoicesModule = {
  state: {
    isRequesting: false,
    errored: false,
    error: ""
  },
  actions: {
    getInvoiceLink({
      commit
    }, tabId) {
      return new Promise(async (resolve, reject) => {
        commit("getInvoiceRequest");
        return axios
          .get(`${API.BASE_URL}${API.INVOICES}${API.TAB}/${tabId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("getInvoiceSuccess");
              resolve(response.data);
            } else {
              commit("getInvoiceError", response.data);
              reject(response.data);
            }
          })
          .catch(error => {
            commit("getInvoiceError", error);
            reject(error);
          });
      });
    },
    sendInvoice({
      commit
    }, { email, tabId }) {
      return new Promise(async (resolve, reject) => {
        commit("sendInvoiceRequest");
        const formData = {
          email,
          tabId
        }
        return axios
          .post(`${API.BASE_URL}${API.INVOICES}${API.TAB}`, formData, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("sendInvoiceSuccess");
              resolve(response.data.original);
            } else {
              commit("sendInvoiceError", response.data);
              reject(response.data);
            }
          })
          .catch(error => {
            commit("sendInvoiceError", error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    sendInvoiceRequest(state) {
      state.isRequesting = true;
    },
    sendInvoiceSuccess(state) {
      state.isRequesting = false;
    },
    sendInvoiceError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    getInvoiceRequest(state, error) {
      state.isRequesting = true;
    },
    getInvoiceSuccess(state, error) {
      state.isRequesting = false;
    },
    getInvoiceError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
  }
};